import React, { useState, useEffect, useMemo } from "react";
import { useGetApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import {
  convertStringToArray,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import usePagination from "../../hooks/usePagination";
import Pagination from "../../components/Pagination/Pagination";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../../components/PdfZipItem";

const ListOfDebarredCompanies = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTenders, setFilteredTenders] = useState([]);
  const { getText } = useLanguageTranslation();
  const {
    data: listOfDebarredCompaniesData = [],
    isLoading: listOfDebarredCompaniesIsLoading,
  } = useGetApiQuery({ url: "list_of_debarred_company", lang: languageType });

  useTableResponsive(listOfDebarredCompaniesData);

  const transformedData = useMemo(() => {
    return listOfDebarredCompaniesData.map((item) => ({
      ...item,
      title1: item.title,
      field_publications_document: convertStringToArray(
        item.field_publications_document,
      ),
    }));
  }, [listOfDebarredCompaniesData]);

  useEffect(() => {
    if (searchTerm) {
      setFilteredTenders(
        transformedData.filter((tender) =>
          tender.title1.toLowerCase().includes(searchTerm.toLowerCase()),
        ),
      );
    } else {
      setFilteredTenders(transformedData);
    }
  }, [searchTerm, transformedData]);

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(filteredTenders, 12);

  // const lastUpdatedOn = useMemo(() => {
  //   return extractDate(listOfDebarredCompaniesData?.[0]);
  // }, [listOfDebarredCompaniesData]);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(listOfDebarredCompaniesData)?.changed,
    );
  }, [listOfDebarredCompaniesData]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (listOfDebarredCompaniesIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Tender", "निविदा")}
        titleLink="/tender/list-of-debarred-companies"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>
                          {getText(
                            "Department/Establishment",
                            "विभाग / स्थापना",
                          )}
                        </th>
                        <th>{getText("Documents", "दस्तावेज़")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {item.counter}
                          </td>
                          <td
                            data-key={getText(
                              "Department/Establishment",
                              "विभाग / स्थापना",
                            )}
                          >
                            <div
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            ></div>
                          </td>
                          <td data-key={getText("Documents", "दस्तावेज़")}>
                            {item?.field_publications_document?.map(
                              (item, i) => (
                                <PdfZipItem
                                  key={i}
                                  filePath={item?.file_path}
                                  title={item.title}
                                  filesize={item.file_size}
                                />
                              ),
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ListOfDebarredCompanies;
